'use strict';

var jsxRuntime = require('react/jsx-runtime');

const MediumStar = ({ testId, className, solid })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? jsxRuntime.jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.95701 1.19816C7.23588 0.623827 7.92198 0.399802 8.48324 0.654451C8.72485 0.764073 8.92474 0.954548 9.04303 1.19816L10.7828 4.78115L14.7145 5.36141C15.3274 5.45186 15.7883 6.01922 15.6862 6.66603C15.6481 6.9069 15.5335 7.12661 15.3629 7.29567L12.496 10.1362L13.1682 14.1211C13.2772 14.7669 12.822 15.3391 12.2098 15.4356C11.9594 15.4751 11.7015 15.4324 11.4765 15.3122L8.00002 13.4543L4.52352 15.3122C3.97888 15.6032 3.28115 15.4216 2.96546 14.8696C2.83621 14.6436 2.78819 14.3796 2.8318 14.1211L3.50399 10.1362L0.637133 7.29567C0.179397 6.84214 0.189431 6.10648 0.657523 5.66504C0.831798 5.50069 1.0518 5.39591 1.28552 5.36141L5.21725 4.78115L6.95701 1.19816Z",
            fill: "currentColor"
        }) : jsxRuntime.jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.41328 1.50393L10.3146 5.41966L14.6123 6.05393C14.8615 6.09072 15.0328 6.31588 14.9947 6.55684C14.9803 6.64797 14.9368 6.73245 14.8702 6.79843L11.7453 9.89455L12.4779 14.2375C12.5185 14.4781 12.3497 14.7049 12.1008 14.7442C11.9997 14.7601 11.896 14.7427 11.8064 14.6948L7.99997 12.6606L4.19354 14.6948C3.97285 14.8128 3.69505 14.7354 3.57305 14.5221C3.52349 14.4355 3.50551 14.3352 3.522 14.2375L4.25459 9.89455L1.12977 6.79843C0.953678 6.62396 0.957246 6.34453 1.13774 6.17432C1.206 6.10994 1.2934 6.06784 1.38767 6.05393L5.68533 5.41966L7.58665 1.50393C7.69379 1.28327 7.9657 1.18836 8.19397 1.29193C8.29042 1.33569 8.36801 1.41069 8.41328 1.50393Z",
            stroke: "currentColor",
            strokeWidth: "1.4"
        })
    });
};

module.exports = MediumStar;
